import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { s__ } from '@design-system/i18n';
import { ScreenReadersContent } from '@design-system/screen-readers-content';
import { useTheme } from '@design-system/theme';
import { BaseInput } from './BaseInput';
const DynamicIcon = ({ handleClick, typeAsPassword, }) => {
    const theme = useTheme();
    return (_jsxs(Box, { alignItems: "center", "aria-label": typeAsPassword
            ? s__('ResetPasswordAccessibility|Make password readable')
            : s__('ResetPasswordAccessibility|Make password not readable'), color: theme.input.iconColor, "data-testid": "password-visibility-icons-container", height: "100%", justifyContent: "center", onClick: handleClick, onKeyDown: onEnterOrSpacePress(handleClick), role: "button", tabIndex: 0, width: "100%", children: [_jsx(FontAwesomeIcon, { height: "16px", iconName: typeAsPassword ? 'eye' : 'eye-slash' }), _jsx(ScreenReadersContent, { children: typeAsPassword
                    ? s__('ResetPasswordAccessibility|Make password readable')
                    : s__('ResetPasswordAccessibility|Make password not readable') })] }));
};
export const PasswordInput = forwardRef((_a, ref) => {
    var { labelPosition = 'top', variant = 'normal', width = '100%' } = _a, otherProps = __rest(_a, ["labelPosition", "variant", "width"]);
    const [typeAsPassword, setTypeAsPassword] = useState(true);
    const handleIconClick = () => {
        setTypeAsPassword(!typeAsPassword);
    };
    return (_jsx(BaseInput, Object.assign({}, otherProps, { icon: () => (_jsx(DynamicIcon, { handleClick: handleIconClick, typeAsPassword: typeAsPassword })), iconIsClickable: true, labelPosition: labelPosition, ref: ref, type: typeAsPassword ? 'password' : 'text', variant: variant, width: width })));
});
//# sourceMappingURL=PasswordInput.js.map